import { useSnackbar } from '@/hooks/useSnackbar';
import {
  curtirResenhaUsuario,
  reportarResenhaUsuario,
} from '@/services/resenhaService';
import { ArgumentosReportarResenha } from '@/services/types/resenha';
import { useState } from 'react';

function useResenhaHook() {
  const [loadingResenha, setLoadingResenha] = useState(false);

  const { mostrarSnackbar } = useSnackbar();

  async function curtirResenha(usuarioTituloID: string, curtir: boolean) {
    try {
      const response = await curtirResenhaUsuario(usuarioTituloID, curtir);

      if (response.sucesso === false) {
        throw new Error(response.mensagem);
      }

      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    }
  }

  async function reportarResenha(props: ArgumentosReportarResenha) {
    try {
      setLoadingResenha(true);
      const response = await reportarResenhaUsuario(props);

      if (response.sucesso === false) {
        throw new Error(response.mensagem);
      }

      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setLoadingResenha(false);
    }
  }

  return {
    loadingResenha,
    curtirResenha,
    reportarResenha,
  };
}

export type useResenhaHookType = ReturnType<typeof useResenhaHook>;

export default useResenhaHook;
